import { TypeInput, ValidationTextField } from '@bloomays-lib/ui.shared';
import { FR_SIRET_REGEX_STRING } from '@bloomays-lib/utils.shared';

export type SocietyRegistrationNumberTextFieldMode = 'siret' | 'european' | 'foreign';

export type SocietyRegistrationNumberTextFieldProps = {
  name?: string;
  required?: boolean;
  value: string;
  onChange?: (e: { target: { value: string; [key: string]: any } }) => void;
  id?: string;
  hidden?: boolean;
  formElement?: boolean;
  fieldMode: SocietyRegistrationNumberTextFieldMode;
};

const SocietyRegistrationNumberTextField = (props: SocietyRegistrationNumberTextFieldProps) => {
  let label = "Siret ou numéro d'Entreprise Individuelle";
  let placeholder = '14 chiffres';
  let pattern = FR_SIRET_REGEX_STRING;
  switch (props.fieldMode) {
    case 'european':
      // Numéro d'enregistrement local libre (formats non maîtrisés, TEC-3187) ;
      // la TVA intracommunautaire est saisie dans son propre champ.
      label = "Numéro d'enregistrement de la société";
      placeholder = "Numéro d'immatriculation dans le pays d'origine";
      pattern = '(\\d||\\w)+';
      break;
    case 'foreign':
      label = "Numéro d'entreprise étrangère (DUNS, etc.)";
      placeholder = 'XXXXXX';
      pattern = '(\\d||\\w)+';
      break;
  }
  return (
    <ValidationTextField
      label={label}
      hidden={props.hidden}
      type={TypeInput.text}
      placeholder={placeholder}
      pattern={pattern}
      formElement={props.formElement}
      {...props}
    />
  );
};

export default SocietyRegistrationNumberTextField;
export { SocietyRegistrationNumberTextField };
